export interface EntryLink {
  name: string;
  badge?: '新' | '热' | '荐';
}

export interface Collection {
  id: string;
  index: string;
  title: string;
  en: string;
  desc: string;
  count: string;
  links: EntryLink[];
}

export interface TopicItem {
  name: string;
  heat: number;
}

export interface UpdateItem {
  kind: '新增' | '修复' | '更新';
  text: string;
  scope: string;
  date: string;
}

export interface CoverItem {
  index: string;
  category: string;
  title: string;
  sub: string;
  tags: number;
  image: string;
}

export const STATS = [
  { num: '128', label: '持续收录入口' },
  { num: '6', label: '精选分类合集' },
  { num: '24h', label: '失效随时补充' },
];

export const COLLECTIONS: Collection[] = [
  {
    id: 'film',
    index: '01',
    title: '影视剧集',
    en: 'Film & Series',
    desc: '热播与经典片单的直达合集，追剧不用东找西找。',
    count: '34 个入口',
    links: [
      { name: '热剧直通车', badge: '热' },
      { name: '高分电影库' },
      { name: '悬疑剧场', badge: '荐' },
      { name: '经典老片' },
      { name: '美剧合集' },
      { name: '韩剧速看' },
      { name: '日剧小屋' },
      { name: '国产热播', badge: '新' },
    ],
  },
  {
    id: 'variety',
    index: '02',
    title: '综艺动漫',
    en: 'Variety & Anime',
    desc: '真人秀、音综与番剧追更，轻松的娱乐补给站。',
    count: '28 个入口',
    links: [
      { name: '真人秀现场', badge: '热' },
      { name: '音综 Live' },
      { name: '脱口秀' },
      { name: '国漫新番' },
      { name: '日漫追更' },
      { name: '剧场版', badge: '荐' },
      { name: '搞笑集锦' },
    ],
  },
  {
    id: 'live',
    index: '03',
    title: '实时直播',
    en: 'Live & Radio',
    desc: '演出、赛事与电台的实时入口，不错过每一场热闹。',
    count: '19 个入口',
    links: [
      { name: '演唱会直播', badge: '热' },
      { name: '赛事转播' },
      { name: '资讯直播' },
      { name: '电台 FM' },
      { name: '慢直播' },
      { name: '现场回看', badge: '新' },
    ],
  },
  {
    id: 'news',
    index: '04',
    title: '热榜资讯',
    en: 'Hot & News',
    desc: '全网热搜与影视速递，快速扫一眼圈内新鲜事。',
    count: '22 个入口',
    links: [
      { name: '全网热搜', badge: '热' },
      { name: '影视资讯' },
      { name: '明星动态' },
      { name: '圈内速递' },
      { name: '片单推荐', badge: '荐' },
      { name: '每周盘点', badge: '新' },
    ],
  },
  {
    id: 'search',
    index: '05',
    title: '资源 · 搜索',
    en: 'Search & Aggregator',
    desc: '聚合搜索与片源聚合，想看什么一次直达找到。',
    count: '17 个入口',
    links: [
      { name: '看料直达搜索', badge: '荐' },
      { name: '聚合搜索' },
      { name: '弹幕影评' },
      { name: '字幕下载' },
      { name: '磁力集合' },
      { name: '网盘资源' },
    ],
  },
  {
    id: 'tool',
    index: '06',
    title: '实用工具',
    en: 'Daily Tools',
    desc: '测速、去广告、转格式等小工具，追剧路上更顺手。',
    count: '14 个入口',
    links: [
      { name: '网速测速' },
      { name: '广告拦截' },
      { name: '格式转换' },
      { name: '字幕适配' },
      { name: '链接检测', badge: '新' },
      { name: '弹幕助手' },
    ],
  },
];

export const HOT_TOPICS: TopicItem[] = [
  { name: '高分悬疑片单', heat: 96 },
  { name: '顶流综艺现场', heat: 91 },
  { name: '演唱会全程回放', heat: 87 },
  { name: '口碑国漫追更', heat: 84 },
  { name: '新剧首播速递', heat: 79 },
  { name: '经典翻拍盘点', heat: 72 },
  { name: '全网热搜榜', heat: 68 },
  { name: '片荒必收清单', heat: 61 },
  { name: '影视冷知识', heat: 55 },
  { name: '弹幕神评现场', heat: 49 },
];

export const UPDATES: UpdateItem[] = [
  { kind: '新增', scope: '资源 · 搜索', text: '「看料直达搜索」入口已上架，聚合更快', date: '今天' },
  { kind: '更新', scope: '影视剧集', text: '新增 2 个高分电影直达入口', date: '昨天' },
  { kind: '修复', scope: '实时直播', text: '某赛事转播入口已补链，恢复可访问', date: '3 天前' },
  { kind: '新增', scope: '综艺动漫', text: '国漫新番专区补充 3 个追更入口', date: '5 天前' },
  { kind: '更新', scope: '热榜资讯', text: '热搜榜单入口刷新至最新版本', date: '6 天前' },
  { kind: '修复', scope: '实用工具', text: '测速助手地址调整后已重新收录', date: '一周前' },
];

export const COVERS: CoverItem[] = [
  {
    index: 'NO.1',
    category: '影视剧集',
    title: '本周悬疑片单',
    sub: '夜色、真相与反转的深夜读物',
    tags: 12,
    image: 'https://readdy.ai/api/search-image?query=Moody%20film%20noir%20editorial%20cover%20art%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20silhouette%20of%20a%20figure%20standing%20under%20a%20vintage%20desk%20lamp%2C%20grainy%20cinematic%20texture%2C%20retro%20magazine%20cover%20style%2C%20elegant%20minimal%20composition%2C%20high%20contrast%20dramatic%20lighting%2C%20no%20text&width=600&height=800&seq=kanliao-cover-01&orientation=portrait',
  },
  {
    index: 'NO.2',
    category: '动漫番剧',
    title: '新番追更地图',
    sub: '从这个入口开启这一季的冒险',
    tags: 9,
    image: 'https://readdy.ai/api/search-image?query=Warm%20geometric%20editorial%20illustration%20of%20an%20animated%20adventure%20scene%2C%20sunrise%20gradient%20in%20coral%20amber%20and%20cream%2C%20stylized%20rolling%20hills%20and%20tiny%20characters%20walking%20toward%20the%20horizon%2C%20clean%20retro%20poster%20layout%2C%20subtle%20paper%20grain%2C%20modern%20minimal%20art%2C%20no%20text&width=600&height=800&seq=kanliao-cover-02&orientation=portrait',
  },
  {
    index: 'NO.3',
    category: '实时直播',
    title: '演出现场直击',
    sub: '今晚的舞台灯光，从直达入口亮起',
    tags: 7,
    image: 'https://readdy.ai/api/search-image?query=Live%20concert%20editorial%20cover%20art%2C%20warm%20golden%20spotlight%20beams%20cutting%20through%20haze%2C%20silhouetted%20crowd%20with%20raised%20hands%2C%20amber%20and%20red%20stage%20glow%2C%20cinematic%20bokeh%2C%20dramatic%20energetic%20music%20poster%20aesthetic%2C%20no%20text&width=600&height=800&seq=kanliao-cover-03&orientation=portrait',
  },
  {
    index: 'NO.4',
    category: '影评夜读',
    title: '灯下片单手账',
    sub: '慢下来，给今晚挑一部好片',
    tags: 15,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20editorial%20cover%20art%20of%20a%20late%20night%20reading%20corner%2C%20warm%20desk%20lamp%20glow%20over%20stacked%20books%20and%20a%20cup%20of%20tea%2C%20cream%20and%20clay%20tones%2C%20soft%20long%20shadows%2C%20magazine%20lifestyle%20aesthetic%2C%20calm%20and%20refined%2C%20no%20text&width=600&height=800&seq=kanliao-cover-04&orientation=portrait',
  },
];

export const TIPS = [
  {
    title: '收藏这一个入口',
    desc: '把看料网址导航加入浏览器书签，想看内容时一键直达，不用再反复搜索。',
    icon: 'ri-bookmark-line',
  },
  {
    title: '先逛分类合集',
    desc: '按影视、动漫、直播等分类快速定位，找到顺手的那一类，入口都在里面。',
    icon: 'ri-layout-3-line',
  },
  {
    title: '入口失效别着急',
    desc: '偶尔有入口打不开，可以留意「最新收录」栏，失效链接我们都会随时补上。',
    icon: 'ri-refresh-line',
  },
];